<script lang="ts">
    import type {RaceAchievability} from "../../modules/ProgramAchievability"
    type $$Props = RaceAchievability["mpa"]
    export let status: $$Props["status"]
</script>
<div class="text-sm text-slate-500">
    {#if status === "fine"}
    Your fitness will be sufficient to perform the power required. Power is below MPA.
    {:else if status === "warning"}
    Your fitness will be barely sufficient to perform the power required. Your program will lack flexibility.
    {:else}
    Your fitness will not be sufficient to perform the power required. Power will exceed your MPA.
    {/if}
</div>